import { useQuery } from "@tanstack/react-query";
import {
  fetchStandards,
  fetchStandardsSubcategory,
  fetchCodeVariants,
} from "../services/standardsApi";

export const useStandardsQuery = () => {
  return useQuery({
    queryKey: ["standards"],
    queryFn: fetchStandards,
    staleTime: Infinity, // Never refetch - standards are essentially static
  });
};

export const useStandardsSubcategoryQuery = (
  standardDisplayName,
  pipeType,
  standardsList
) => {
  const standardName = standardsList?.results?.find(
    (s) => s.display_name === standardDisplayName
  )?.name;

  const pipeTypeSewer = pipeType === "Sewer";

  return useQuery({
    queryKey: ["standardsSubcategory", standardName, pipeTypeSewer],
    queryFn: () => fetchStandardsSubcategory(standardName, pipeTypeSewer),
    enabled: !!standardName && !!pipeType, // Only run if we have both parameters
    staleTime: Infinity, // Never refetch - subcategories are essentially static
  });
};

export const useCodeVariantsQuery = (subcategoryId) => {
  return useQuery({
    queryKey: ["codeVariants", subcategoryId],
    queryFn: () => fetchCodeVariants(subcategoryId),
    enabled: !!subcategoryId, // Only run if we have a subcategory ID
    staleTime: Infinity, // Never refetch - code variants are essentially static
  });
};
